class PrintController {
    /*@ngInject*/
    constructor($translate) {
        this.$translate = $translate;
        this.model = {
            contactRequestObj: null
        };
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.contactRequestObj = window.opener.w.printData;
            this.print();
        }
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 1500)
    }
}
export default PrintController;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/print/contact_request_print.controller.js